import i18n, { SupportedLocale } from "@/i18n";
import {
  computeFieldMultipleprintDimensionImage,
  computeFieldMultipleprintDimensions,
  computeFieldMultipleprintRelatedAuthors,
} from "@/lib/computeFields";
import { AdvancedSearchConfig } from "../forms/advanced-search/advanced-search-fields-def";
import { ColumnFormatted } from "./general";

export const multipleprintsColumns: ColumnFormatted[] = [
  {
    type: "string",
    key: "estampesMultiplesDescriptionNumeroEnregistrement",
    visible: true,
  },
  { type: "image", key: "vignette", visible: true },
  {
    type: "computed",
    key: "estampesDescriptionNomArtisteComplet",
    visible: true,
    formattedData(data) {
      return computeFieldMultipleprintRelatedAuthors(data, {
        language: i18n.language as SupportedLocale,
      });
    },
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionAuteurArtisteAttribueA",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionAuteurArtisteAnonyme",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionAuteurArtisteDApres",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionAuteurArtisteDansLeGoutDe",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionAuteurArtisteEntourageDe",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionAuteurAtelierDe",
    visible: false,
  },
  { type: "string", key: "estampesMultiplesDescriptionTitre", visible: true },
  {
    type: "string",
    key: "estampesMultiplesDescriptionSousTitre",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionTitreSansTitre",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionTitreInconnu",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionTitreIncertin",
    visible: false,
  },
  {
    type: "string",
    key: "estampesMultiplesDescriptionDateDeCreation",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionDateDeCreationInconnue",
    visible: false,
  },
  { type: "string", key: "estampesMultiplesDescriptionType", visible: true },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionOeuvreDoubleFace",
    visible: false,
  },
  {
    type: "string",
    key: "estampesMultiplesDescriptionTechniqueFRA",
    visible: true,
  },
  {
    type: "string",
    key: "estampesMultiplesDescriptionTechniqueGB",
    visible: false,
  },
  {
    type: "string",
    key: "estampesMultiplesDescriptionSupportMateriauFRA",
    visible: true,
  },
  {
    type: "string",
    key: "estampesMultiplesDescriptionSupportMateriauGB",
    visible: false,
  },
  {
    type: "string",
    key: "estampesMultiplesDescriptionEditeur",
    visible: false,
  },
  {
    type: "string",
    key: "estampesMultiplesDescriptionFabricantImprimeur",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionDimensionsProfondeur",
    visible: false,
  },
  {
    type: "computed",
    key: "estampesMultiplesDescriptionDimensionsOeuvre",
    visible: true,
    formattedData(data) {
      return computeFieldMultipleprintDimensions(data, {
        language: i18n.language as SupportedLocale,
      });
    },
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionDimensionsOeuvreVerifiees",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionDimensionsOeuvreInconnues",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionDimensionsOeuvreDouteuses",
    visible: false,
  },
  {
    type: "computed",
    key: "estampesMultiplesDescriptionDimensionsImage",
    visible: false,
    formattedData(data) {
      return computeFieldMultipleprintDimensionImage(data, {
        language: i18n.language as SupportedLocale,
      });
    },
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionDimensionsImageVerifiees",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionDimensionsImageInconnues",
    visible: false,
  },
  {
    type: "boolean",
    key: "estampesMultiplesDescriptionDimensionsImageDouteuses",
    visible: false,
  },
  {
    type: "string",
    key: "estampesMultiplesDescriptionPoidsOeuvre",
    visible: false,
  },
  {
    type: "richtext",
    key: "estampesMultiplesDescriptionDescriptionComplete",
    visible: false,
  },
  {
    type: "richtext",
    key: "estampesMultiplesDescriptionResume",
    visible: false,
  },
  {
    type: "string",
    key: "estampesMultiplesDescriptionSignatureLocalisationFR",
    visible: false,
  },
  {
    type: "string",
    key: "estampesMultiplesDescriptionSignatureLocalisationGB",
    visible: false,
  },
  {
    type: "string",
    key: "estampesMultiplesDescriptionSignatureTranscription",
    visible: false,
  },
  {
    type: "string",
    key: "estampesMultiplesDescriptionInscriptionsDosFR",
    visible: false,
  },
  {
    type: "string",
    key: "estampesMultiplesDescriptionInscriptionsDosEN",
    visible: false,
  },
  {
    type: "richtext",
    key: "estampesMultiplesDescriptionNotesTravail",
    visible: false,
  },
  {
    type: "richtext",
    key: "estampesMultiplesDescriptionNotesPubliques",
    visible: false,
  },
  { type: "status", key: "estampesMultiplesPublicationStatus", visible: true },
  { type: "string", key: "sources", visible: false },
];

export const multipleprintsAdvancedSearchConfig: AdvancedSearchConfig = [
  {
    type: "group",
    label: "multipleprintsDescription",
    fields: [
      {
        type: "string",
        key: "estampesMultiplesDescriptionNumeroEnregistrement",
      },
      {
        type: "boolean",
        key: "estampesMultiplesDescriptionAuteurArtisteAttribueA",
      },
      {
        type: "boolean",
        key: "estampesMultiplesDescriptionAuteurArtisteAnonyme",
      },
      {
        type: "boolean",
        key: "estampesMultiplesDescriptionAuteurArtisteDApres",
      },
      {
        type: "boolean",
        key: "estampesMultiplesDescriptionAuteurArtisteDansLeGoutDe",
      },
      {
        type: "boolean",
        key: "estampesMultiplesDescriptionAuteurArtisteEntourageDe",
      },
      { type: "boolean", key: "estampesMultiplesDescriptionAuteurAtelierDe" },
      { type: "string", key: "estampesMultiplesDescriptionTitre" },
      { type: "string", key: "estampesMultiplesDescriptionSousTitre" },
      { type: "boolean", key: "estampesMultiplesDescriptionTitreSansTitre" },
      { type: "boolean", key: "estampesMultiplesDescriptionTitreInconnu" },
      { type: "boolean", key: "estampesMultiplesDescriptionTitreIncertin" },
      { type: "string", key: "estampesMultiplesDescriptionType" },
      { type: "boolean", key: "estampesMultiplesDescriptionOeuvreDoubleFace" },
      {
        type: "boolean",
        key: "estampesMultiplesDescriptionDateDeCreationInconnue",
      },
      { type: "multilingual", key: "estampesMultiplesDescriptionTechnique" },
      {
        type: "multilingual",
        key: "estampesMultiplesDescriptionSupportMateriau",
      },
      { type: "string", key: "estampesMultiplesDescriptionEditeur" },
      { type: "string", key: "estampesMultiplesDescriptionFabricantImprimeur" },
      { type: "string", key: "estampesMultiplesDescriptionResume" },
      {
        type: "multilingual",
        key: "estampesMultiplesDescriptionSignatureLocalisation",
      },
      {
        type: "string",
        key: "estampesMultiplesDescriptionSignatureTranscription",
      },
      {
        type: "multilingual",
        key: "estampesMultiplesDescriptionInscriptionsDos",
      },
      { type: "string", key: "estampesMultiplesDescriptionNotesTravail" },
      { type: "string", key: "estampesMultiplesDescriptionNotesPubliques" },
      {
        type: "string",
        key: "estampesMultiplesDescriptionDimensionsOeuvreRaw",
      },
    ],
  },
  {
    type: "group",
    label: "epreuveTirage",
    fields: [
      {
        type: "string",
        key: "estampesMultiplesDescriptionDescriptionComplete",
      },
    ],
  },
  {
    type: "group",
    label: "sources",
    fields: [{ type: "string", key: "sources" }],
  },
];
